import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
/** Create a new task */ export const createTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.task === undefined) {
        throw new Error('Missing required body: task');
    }
    const path = '/api/ws-funnel/tasks';
    const pathInternal = '/api/tasks';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.task !== undefined) {
        body = params.task;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTask.paramsOrder = [{ type: 'body', paramName: 'task' }];
export const getPaginatedTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-funnel/tasks/get';
    const pathInternal = '/api/tasks/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedTasks.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getBatchActivities = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/batch/activities';
    const pathInternal = '/api/batch/activities';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchActivities.paramsOrder = [{ type: 'parameters' }];
/** Create a new task */ export const createTaskBatch = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskBatchForm === undefined) {
        throw new Error('Missing required body: taskBatchForm');
    }
    const path = '/api/ws-funnel/tasks/batch';
    const pathInternal = '/api/tasks/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskBatchForm !== undefined) {
        body = params.taskBatchForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTaskBatch.paramsOrder = [{ type: 'body', paramName: 'taskBatchForm' }];
export const getTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTask.paramsOrder = [{ type: 'parameters' }];
/** Update task */ export const updateTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.task === undefined) {
        throw new Error('Missing required body: task');
    }
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.task !== undefined) {
        body = params.task;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTask.paramsOrder = [{ type: 'body', paramName: 'task' }, { type: 'parameters' }];
/** Delete task (only if lead) */ export const archiveTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveTask.paramsOrder = [{ type: 'parameters' }];
/** Delete tasks (only if lead) */ export const archiveTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskIds === undefined) {
        throw new Error('Missing required body: taskIds');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/archive/bulk';
    const pathInternal = '/api/tasks/archive/bulk';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskIds !== undefined) {
        body = params.taskIds;
    }
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
archiveTasks.paramsOrder = [{ type: 'body', paramName: 'taskIds' }, { type: 'parameters' }];
export const updateTaskSnoozedTime = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/update_snoozed'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/update_snoozed'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.snoozedDate : (params.snoozedDate ?? queryDefaults?.['snoozedDate']);
        if (value !== undefined) {
            urlParams.append('snoozedDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.notifyUnsnoozed : (params.notifyUnsnoozed ?? queryDefaults?.['notifyUnsnoozed']);
        if (value !== undefined) {
            urlParams.append('notifyUnsnoozed', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.comment : (params.comment ?? queryDefaults?.['comment']);
        if (value !== undefined) {
            urlParams.append('comment', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTaskSnoozedTime.paramsOrder = [{ type: 'parameters' }];
export const updateTasksOwnersByAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-funnel/tasks/update_task_owners_by_account';
    const pathInternal = '/api/tasks/update_task_owners_by_account';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    {
        const value = queryDefaults === false ? params.newOwnerName : (params.newOwnerName ?? queryDefaults?.['newOwnerName']);
        if (value !== undefined) {
            urlParams.append('newOwnerName', value.toString());
        }
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateTasksOwnersByAccount.paramsOrder = [{ type: 'parameters' }];
export const finishTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.outcome === undefined) {
        throw new Error('Missing required parameter: outcome');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/finish'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/finish'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.campaignId : (params.campaignId ?? queryDefaults?.['campaignId']);
        if (value !== undefined) {
            urlParams.append('campaignId', value.toString());
        }
    }
    if (params.outcome !== undefined) {
        urlParams.append('outcome', params.outcome.toString());
    }
    {
        const value = queryDefaults === false ? params.comment : (params.comment ?? queryDefaults?.['comment']);
        if (value !== undefined) {
            urlParams.append('comment', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
finishTask.paramsOrder = [{ type: 'parameters' }];
export const restoreTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/restore'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/restore'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.comment : (params.comment ?? queryDefaults?.['comment']);
        if (value !== undefined) {
            urlParams.append('comment', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreTask.paramsOrder = [{ type: 'parameters' }];
export const restoreArchivedTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/archived/restore'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/archived/restore'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
restoreArchivedTask.paramsOrder = [{ type: 'parameters' }];
export const sendEmailToContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.emailTemplate === undefined) {
        throw new Error('Missing required body: emailTemplate');
    }
    const path = '/api/ws-funnel/activities/email';
    const pathInternal = '/api/activities/email';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    {
        const value = queryDefaults === false ? params.taskId : (params.taskId ?? queryDefaults?.['taskId']);
        if (value !== undefined) {
            urlParams.append('taskId', value.toString());
        }
    }
    if (params.emailTemplate !== undefined) {
        body = params.emailTemplate;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendEmailToContact.paramsOrder = [{ type: 'body', paramName: 'emailTemplate' }, { type: 'parameters' }];
export const assignTask = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.assigneeId === undefined) {
        throw new Error('Missing required parameter: assigneeId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/assign/{assigneeId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{assigneeId}', params.assigneeId?.toString());
    const pathInternal = '/api/tasks/{taskId}/assign/{assigneeId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{assigneeId}', params.assigneeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
assignTask.paramsOrder = [{ type: 'parameters' }];
export const assignTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskIds === undefined) {
        throw new Error('Missing required body: taskIds');
    }
    if (params.assigneeId === undefined) {
        throw new Error('Missing required parameter: assigneeId');
    }
    const path = '/api/ws-funnel/tasks/assign/{assigneeId}/bulk'.replace('{assigneeId}', params.assigneeId?.toString());
    const pathInternal = '/api/tasks/assign/{assigneeId}/bulk'.replace('{assigneeId}', params.assigneeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskIds !== undefined) {
        body = params.taskIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
assignTasks.paramsOrder = [{ type: 'body', paramName: 'taskIds' }, { type: 'parameters' }];
export const updateLastCommentTime = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/update-last-comment'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/update-last-comment'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateLastCommentTime.paramsOrder = [{ type: 'parameters' }];
export const removeLabel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.labelId === undefined) {
        throw new Error('Missing required parameter: labelId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/labels/{labelId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{labelId}', params.labelId?.toString());
    const pathInternal = '/api/tasks/{taskId}/labels/{labelId}'
        .replace('{taskId}', params.taskId?.toString())
        .replace('{labelId}', params.labelId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeLabel.paramsOrder = [{ type: 'parameters' }];
export const getTaskContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskContacts.paramsOrder = [{ type: 'parameters' }];
export const addContactAsDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addContactAsDefault.paramsOrder = [{ type: 'parameters' }];
export const removeTaskContactFromDefault = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskId === undefined) {
        throw new Error('Missing required parameter: taskId');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    const pathInternal = '/api/tasks/{taskId}/contacts'.replace('{taskId}', params.taskId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeTaskContactFromDefault.paramsOrder = [{ type: 'parameters' }];
export const getStatuses = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/tasks/statuses';
    const pathInternal = '/api/tasks/statuses';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getStatuses.paramsOrder = [];
export const getSalesPersons = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/users/sales';
    const pathInternal = '/api/users/sales';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPersons.paramsOrder = [{ type: 'parameters' }];
export const getSources = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/sources';
    const pathInternal = '/api/sources';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSources.paramsOrder = [{ type: 'parameters' }];
export const createSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.source === undefined) {
        throw new Error('Missing required body: source');
    }
    const path = '/api/ws-funnel/sources';
    const pathInternal = '/api/sources';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.source !== undefined) {
        body = params.source;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSource.paramsOrder = [{ type: 'body', paramName: 'source' }];
export const getSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSource.paramsOrder = [{ type: 'parameters' }];
export const updateSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.source === undefined) {
        throw new Error('Missing required body: source');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.source !== undefined) {
        body = params.source;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSource.paramsOrder = [{ type: 'body', paramName: 'source' }, { type: 'parameters' }];
export const deleteSource = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/sources/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/sources/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSource.paramsOrder = [{ type: 'parameters' }];
export const getTaskTopics = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/tasks/topics';
    const pathInternal = '/api/tasks/topics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskTopics.paramsOrder = [{ type: 'parameters' }];
export const createTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.taskTopic === undefined) {
        throw new Error('Missing required body: taskTopic');
    }
    const path = '/api/ws-funnel/tasks/topics';
    const pathInternal = '/api/tasks/topics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskTopic !== undefined) {
        body = params.taskTopic;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createTaskTopic.paramsOrder = [{ type: 'body', paramName: 'taskTopic' }];
export const updateTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.taskTopic === undefined) {
        throw new Error('Missing required body: taskTopic');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.taskTopic !== undefined) {
        body = params.taskTopic;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateTaskTopic.paramsOrder = [{ type: 'body', paramName: 'taskTopic' }, { type: 'parameters' }];
export const deleteTaskTopic = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteTaskTopic.paramsOrder = [{ type: 'parameters' }];
export const getTaskTopicsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-funnel/tasks/topics/by-ids';
    const pathInternal = '/api/tasks/topics/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTaskTopicsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
export const getSalesfunnelLabels = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/labels/salesfunnel';
    const pathInternal = '/api/labels/salesfunnel';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.nameFilter : (params.nameFilter ?? queryDefaults?.['nameFilter']);
        if (value !== undefined) {
            urlParams.append('nameFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesfunnelLabels.paramsOrder = [{ type: 'parameters' }];
export const updateSalesFunnelLabel = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.label === undefined) {
        throw new Error('Missing required body: label');
    }
    const path = '/api/ws-funnel/labels/salesfunnel/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/labels/salesfunnel/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.label !== undefined) {
        body = params.label;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesFunnelLabel.paramsOrder = [{ type: 'body', paramName: 'label' }, { type: 'parameters' }];
export const getReportingTasks = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/reporting/tasks';
    const pathInternal = '/api/reporting/tasks';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingTasks.paramsOrder = [{ type: 'parameters' }];
export const getReportingTasksCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/reporting/tasks/cursor';
    const pathInternal = '/api/reporting/tasks/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingTasksCursor.paramsOrder = [{ type: 'parameters' }];
export const getBatchActivitiesCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-funnel/batch/activities/cursor';
    const pathInternal = '/api/batch/activities/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchActivitiesCursor.paramsOrder = [{ type: 'parameters' }];
/** Create new FormTemplate */ export const createFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.formTemplateForm === undefined) {
        throw new Error('Missing required body: formTemplateForm');
    }
    const path = '/api/ws-funnel/form-templates';
    const pathInternal = '/api/form-templates';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateForm !== undefined) {
        body = params.formTemplateForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createFormTemplate.paramsOrder = [{ type: 'body', paramName: 'formTemplateForm' }];
/** Update form template */ export const updateFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    if (params.formTemplateForm === undefined) {
        throw new Error('Missing required body: formTemplateForm');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateForm !== undefined) {
        body = params.formTemplateForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateFormTemplate.paramsOrder = [{ type: 'body', paramName: 'formTemplateForm' }, { type: 'parameters' }];
/** Delete form template by id */ export const deleteFormTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteFormTemplate.paramsOrder = [{ type: 'parameters' }];
export const getPositionLeadReportTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/form-templates/position-lead-report-types';
    const pathInternal = '/api/form-templates/position-lead-report-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionLeadReportTypes.paramsOrder = [];
/** Get form template by campaign position id */ export const getFormTemplateByCampaignPositionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-funnel/campaign-positions/{campaignPositionId}/form-template'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/form-template'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFormTemplateByCampaignPositionId.paramsOrder = [{ type: 'parameters' }];
/** Returns a position leads report */ export const downloadPositionLeadReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-funnel/campaign-positions/{campaignPositionId}/leads/download'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/leads/download'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPositionLeadReport.paramsOrder = [{ type: 'parameters' }];
/** Save form template lead */ export const saveFormTemplateLead = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    if (params.formTemplateLeadForm === undefined) {
        throw new Error('Missing required body: formTemplateLeadForm');
    }
    const path = '/api/ws-funnel/form-templates/save-lead/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/save-lead/{formTemplateId}'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.formTemplateLeadForm !== undefined) {
        body = params.formTemplateLeadForm;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
saveFormTemplateLead.paramsOrder = [
    { type: 'body', paramName: 'formTemplateLeadForm' },
    { type: 'parameters' },
];
export const getPositionLeadsEndpoint = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.formTemplateId === undefined) {
        throw new Error('Missing required parameter: formTemplateId');
    }
    const path = '/api/ws-funnel/form-templates/{formTemplateId}/endpoint'.replace('{formTemplateId}', params.formTemplateId?.toString());
    const pathInternal = '/api/form-templates/{formTemplateId}/endpoint'.replace('{formTemplateId}', params.formTemplateId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getPositionLeadsEndpoint.paramsOrder = [{ type: 'parameters' }];
/** Get paginated sales promotion type configs */ export const getSalesPromotionsTypeConfigs = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/sales-promotions/type-configs';
    const pathInternal = '/api/sales-promotions/type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionsTypeConfigs.paramsOrder = [{ type: 'parameters' }];
/** Create sales promotion type config */ export const createSalesPromotionsTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigForm === undefined) {
        throw new Error('Missing required body: typeConfigForm');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs';
    const pathInternal = '/api/sales-promotions/type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigForm !== undefined) {
        body = params.typeConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSalesPromotionsTypeConfig.paramsOrder = [{ type: 'body', paramName: 'typeConfigForm' }];
/** Get promotion with such name if exists */ export const getPromotionByName = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-funnel/sales-promotions/by-name';
    const pathInternal = '/api/sales-promotions/by-name';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPromotionByName.paramsOrder = [{ type: 'parameters' }];
/** Returns all sales contacts */ export const getSalesContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/contacts/sales';
    const pathInternal = '/api/contacts/sales';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesContacts.paramsOrder = [{ type: 'parameters' }];
/** Returns all contacts available for promotion */ export const getAvailableContactsBySalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/contacts/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/contacts/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.activeAccount : (params.activeAccount ?? queryDefaults?.['activeAccount']);
        if (value !== undefined) {
            urlParams.append('activeAccount', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAvailableContactsBySalesPromotion.paramsOrder = [{ type: 'parameters' }];
/** Returns all sales promotion's not excluded contacts by account id */ export const getSalesPromotionNotExcludedContactsByAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/contacts/not-excluded';
    const pathInternal = '/api/sales-promotions/contacts/not-excluded';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.salesPromotionId !== undefined) {
        urlParams.append('salesPromotionId', params.salesPromotionId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionNotExcludedContactsByAccountId.paramsOrder = [{ type: 'parameters' }];
/** Get type config excluded for contact */ export const getContactsExcludedTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/contacts/excluded-type-configs';
    const pathInternal = '/api/sales-promotions/contacts/excluded-type-configs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getContactsExcludedTypeConfig.paramsOrder = [{ type: 'parameters' }];
/** Get contact ids excluded for type config */ export const getTypeConfigExcludedContactIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigId !== undefined) {
        urlParams.append('typeConfigId', params.typeConfigId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getTypeConfigExcludedContactIds.paramsOrder = [{ type: 'parameters' }];
/** Exclude type config for contact */ export const excludeTypeConfigsForContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigIds === undefined) {
        throw new Error('Missing required body: typeConfigIds');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigIds !== undefined) {
        body = params.typeConfigIds;
    }
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
excludeTypeConfigsForContact.paramsOrder = [
    { type: 'body', paramName: 'typeConfigIds' },
    { type: 'parameters' },
];
/** Remove type config from contact excluded */ export const deleteExcludedTypeConfigsForContact = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigIds === undefined) {
        throw new Error('Missing required body: typeConfigIds');
    }
    if (params.contactId === undefined) {
        throw new Error('Missing required parameter: contactId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/excluded-contacts';
    const pathInternal = '/api/sales-promotions/type-configs/excluded-contacts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigIds !== undefined) {
        body = params.typeConfigIds;
    }
    if (params.contactId !== undefined) {
        urlParams.append('contactId', params.contactId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteExcludedTypeConfigsForContact.paramsOrder = [
    { type: 'body', paramName: 'typeConfigIds' },
    { type: 'parameters' },
];
/** Get type config by id */ export const getSalesPromotionTypeConfigById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionTypeConfigById.paramsOrder = [{ type: 'parameters' }];
/** Update type config */ export const updateSalesPromotionTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    if (params.typeConfigForm === undefined) {
        throw new Error('Missing required body: typeConfigForm');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.typeConfigForm !== undefined) {
        body = params.typeConfigForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotionTypeConfig.paramsOrder = [
    { type: 'body', paramName: 'typeConfigForm' },
    { type: 'parameters' },
];
/** Delete type config */ export const deleteSalesPromotionTypeConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeConfigId === undefined) {
        throw new Error('Missing required parameter: typeConfigId');
    }
    const path = '/api/ws-funnel/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    const pathInternal = '/api/sales-promotions/type-configs/{typeConfigId}'.replace('{typeConfigId}', params.typeConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSalesPromotionTypeConfig.paramsOrder = [{ type: 'parameters' }];
/** Get paginated sales promotions */ export const getSalesPromotions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-funnel/sales-promotions/get';
    const pathInternal = '/api/sales-promotions/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotions.paramsOrder = [{ type: 'body', paramName: 'filter' }];
/** Create new sales promotion */ export const createSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionForm === undefined) {
        throw new Error('Missing required body: salesPromotionForm');
    }
    const path = '/api/ws-funnel/sales-promotions';
    const pathInternal = '/api/sales-promotions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionForm !== undefined) {
        body = params.salesPromotionForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createSalesPromotion.paramsOrder = [{ type: 'body', paramName: 'salesPromotionForm' }];
/** Get sales promotion by id */ export const getSalesPromotionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionById.paramsOrder = [{ type: 'parameters' }];
/** Update sales promotion */ export const updateSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.salesPromotionForm === undefined) {
        throw new Error('Missing required body: salesPromotionForm');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionForm !== undefined) {
        body = params.salesPromotionForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotion.paramsOrder = [{ type: 'body', paramName: 'salesPromotionForm' }, { type: 'parameters' }];
/** Send promotion conatct emails */ export const sendPromotionContactEmails = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.mailForm === undefined) {
        throw new Error('Missing required body: mailForm');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/send-emails'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/send-emails'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mailForm !== undefined) {
        body = params.mailForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
sendPromotionContactEmails.paramsOrder = [{ type: 'body', paramName: 'mailForm' }, { type: 'parameters' }];
/** Create attachments from file ids */ export const createMailTemplateAttachments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.attachmentForms === undefined) {
        throw new Error('Missing required body: attachmentForms');
    }
    const path = '/api/ws-funnel/sales-promotions/mail-template/attachments/create';
    const pathInternal = '/api/sales-promotions/mail-template/attachments/create';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.attachmentForms !== undefined) {
        body = params.attachmentForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createMailTemplateAttachments.paramsOrder = [{ type: 'body', paramName: 'attachmentForms' }];
/** Get sales promotion mail template */ export const getMailTemplateByPromotionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getMailTemplateByPromotionId.paramsOrder = [{ type: 'parameters' }];
/** Update sales promotion mail template */ export const upsertMailTemplateByPromotionId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.mailTemplate === undefined) {
        throw new Error('Missing required body: mailTemplate');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.mailTemplate !== undefined) {
        body = params.mailTemplate;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
upsertMailTemplateByPromotionId.paramsOrder = [
    { type: 'body', paramName: 'mailTemplate' },
    { type: 'parameters' },
];
/** Delete sales promotion mail template */ export const deleteMailTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/mail-template'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteMailTemplate.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion by ids */ export const getSalesPromotionByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionIds === undefined) {
        throw new Error('Missing required body: salesPromotionIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-ids';
    const pathInternal = '/api/sales-promotions/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionIds !== undefined) {
        body = params.salesPromotionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionByIds.paramsOrder = [{ type: 'body', paramName: 'salesPromotionIds' }];
/** Get sales promotion short DTOs by ids */ export const getSalesPromotionShortByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionIds === undefined) {
        throw new Error('Missing required body: salesPromotionIds');
    }
    const path = '/api/ws-funnel/sales-promotions/short/by-ids';
    const pathInternal = '/api/sales-promotions/short/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesPromotionIds !== undefined) {
        body = params.salesPromotionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionShortByIds.paramsOrder = [{ type: 'body', paramName: 'salesPromotionIds' }];
/** Get attachment by id */ export const getAttachmentById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.attachmentId === undefined) {
        throw new Error('Missing required parameter: attachmentId');
    }
    const path = '/api/ws-funnel/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    const pathInternal = '/api/attachments/{attachmentId}'.replace('{attachmentId}', params.attachmentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAttachmentById.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion by id */ export const getSalesPromotionCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/campaigns'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/campaigns'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.phase : (params.phase ?? queryDefaults?.['phase']);
        if (value !== undefined) {
            urlParams.append('phase', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchQuery : (params.searchQuery ?? queryDefaults?.['searchQuery']);
        if (value !== undefined) {
            urlParams.append('searchQuery', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Add sales promotion accounts */ export const addSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.accountForms === undefined) {
        throw new Error('Missing required body: accountForms');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountForms !== undefined) {
        body = params.accountForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addSalesPromotionAccounts.paramsOrder = [{ type: 'body', paramName: 'accountForms' }, { type: 'parameters' }];
/** Get sales promotion account sales contact names */ export const getSalesPromotionAccountSalesContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/sales-contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/sales-contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccountSalesContacts.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion accounts */ export const getSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.taskStatus : (params.taskStatus ?? queryDefaults?.['taskStatus']);
        if (value !== undefined) {
            urlParams.append('taskStatus', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.salesContactName
            : (params.salesContactName ?? queryDefaults?.['salesContactName']);
        if (value !== undefined) {
            urlParams.append('salesContactName', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccounts.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotions by account IDs */ export const getSalesPromotionAccountsByAccountIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-acccount-ids/get';
    const pathInternal = '/api/sales-promotions/by-acccount-ids/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionAccountsByAccountIds.paramsOrder = [{ type: 'body', paramName: 'accountIds' }];
/** Remove sales promotion accounts */ export const removeSalesPromotionAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.accountIds === undefined) {
        throw new Error('Missing required body: accountIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/accounts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/accounts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIds !== undefined) {
        body = params.accountIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeSalesPromotionAccounts.paramsOrder = [{ type: 'body', paramName: 'accountIds' }, { type: 'parameters' }];
/** Get sales promotion contacts */ export const getSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.hasMailingTime : (params.hasMailingTime ?? queryDefaults?.['hasMailingTime']);
        if (value !== undefined) {
            urlParams.append('hasMailingTime', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.gender : (params.gender ?? queryDefaults?.['gender']);
        if (value !== undefined) {
            urlParams.append('gender', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.isFormalFormOfCommunication
            : (params.isFormalFormOfCommunication ?? queryDefaults?.['isFormalFormOfCommunication']);
        if (value !== undefined) {
            urlParams.append('isFormalFormOfCommunication', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.isBounced : (params.isBounced ?? queryDefaults?.['isBounced']);
        if (value !== undefined) {
            urlParams.append('isBounced', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.createdByUserId : (params.createdByUserId ?? queryDefaults?.['createdByUserId']);
        if (value !== undefined) {
            urlParams.append('createdByUserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.addedByUserId : (params.addedByUserId ?? queryDefaults?.['addedByUserId']);
        if (value !== undefined) {
            urlParams.append('addedByUserId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.ownerId : (params.ownerId ?? queryDefaults?.['ownerId']);
        if (value !== undefined) {
            urlParams.append('ownerId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContacts.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion contacts` statuses */ export const getSalesPromotionContactStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/statuses'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/statuses'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactStatuses.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion contacts` created by */ export const getSalesPromotionContactCreatedBy = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/created-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/created-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactCreatedBy.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotion contacts` added by */ export const getSalesPromotionContactAddedBy = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/added-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/added-by'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.searchFilter : (params.searchFilter ?? queryDefaults?.['searchFilter']);
        if (value !== undefined) {
            urlParams.append('searchFilter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactAddedBy.paramsOrder = [{ type: 'parameters' }];
/** Get sales promotions by contacts` IDs */ export const getSalesPromotionContactsByContactIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/by-contact-ids/get';
    const pathInternal = '/api/sales-promotions/by-contact-ids/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getSalesPromotionContactsByContactIds.paramsOrder = [{ type: 'body', paramName: 'contactIds' }];
/** Add sales promotion contacts */ export const addSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactForms === undefined) {
        throw new Error('Missing required body: contactForms');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/add'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactForms !== undefined) {
        body = params.contactForms;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addSalesPromotionContacts.paramsOrder = [{ type: 'body', paramName: 'contactForms' }, { type: 'parameters' }];
/** Update sales promotion contact statuses */ export const updateSalesPromotionContactStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/status'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/status'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.status : (params.status ?? queryDefaults?.['status']);
        if (value !== undefined) {
            urlParams.append('status', value.toString());
        }
    }
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateSalesPromotionContactStatuses.paramsOrder = [
    { type: 'body', paramName: 'contactIds' },
    { type: 'parameters' },
];
/** Remove contacts from sales promotion */ export const removeSalesPromotionContacts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.contactIds === undefined) {
        throw new Error('Missing required body: contactIds');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/contacts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/contacts/remove'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.contactIds !== undefined) {
        body = params.contactIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
removeSalesPromotionContacts.paramsOrder = [{ type: 'body', paramName: 'contactIds' }, { type: 'parameters' }];
/** Clone sales promotion with account and contacts */ export const cloneSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/clone'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/clone'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneSalesPromotion.paramsOrder = [{ type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-funnel/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Returns a promotion report */ export const downloadPromotionReport = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-funnel/sales-promotions/{salesPromotionId}/report/download'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/sales-promotions/{salesPromotionId}/report/download'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadPromotionReport.paramsOrder = [{ type: 'parameters' }];
export const markTaskTopicActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.isActive === undefined) {
        throw new Error('Missing required parameter: isActive');
    }
    const path = '/api/ws-funnel/tasks/topics/{id}/mark/active'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/tasks/topics/{id}/mark/active'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.isActive !== undefined) {
        urlParams.append('isActive', params.isActive.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
markTaskTopicActive.paramsOrder = [{ type: 'parameters' }];
/** Returns comments */ export const getComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.taskId : (params.taskId ?? queryDefaults?.['taskId']);
        if (value !== undefined) {
            urlParams.append('taskId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.contactId : (params.contactId ?? queryDefaults?.['contactId']);
        if (value !== undefined) {
            urlParams.append('contactId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.creatorId : (params.creatorId ?? queryDefaults?.['creatorId']);
        if (value !== undefined) {
            urlParams.append('creatorId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getComments.paramsOrder = [{ type: 'parameters' }];
/** Create comment */ export const createComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-funnel/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createComment.paramsOrder = [{ type: 'body', paramName: 'comment' }];
/** Update comment */ export const updateComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-funnel/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateComment.paramsOrder = [{ type: 'body', paramName: 'comment' }, { type: 'parameters' }];
/** delete comment */ export const deleteComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    const path = '/api/ws-funnel/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteComment.paramsOrder = [{ type: 'parameters' }];
/** Returns all accounts with role either BROKER, AGENCY or ADVERTISER. */ export const getAccountList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-funnel/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includeInactive
            : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountList.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
